// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "nav.breadcrumb[data-v-1c612264] {\n  font-size: 0.8rem;\n}\nnav.breadcrumb ul li:last-child a[data-v-1c612264] {\n  font-weight: bold;\n  color: #2669a0;\n}\n#bread-container .button-dropdown[data-v-1c612264] {\n  font-size: 0.8rem;\n  font-weight: bold;\n  margin-top: -2px;\n}", ""]);
// Exports
module.exports = exports;
